<template>
  <div>
    <v-row no-gutters justify="end" align="center">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn icon v-on="on" @click="refreshData">
            <v-icon>
              autorenew
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $tc('refresh') }}
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn icon v-on="on" @click="openAddModal">
            <v-icon>
              add
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $tc('add_ip') }}
        </span>
      </v-tooltip>

      <v-switch
        id="ntp_status"
        :label="$tc('enable')"
        @click="changeStatus"
        v-model="status"
        :disabled="ntpList.length === 0"
        color="green"
        class="ml-2"
      />
    </v-row>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <ntp-table @deleteAddr="openIpDeleteModal" />
    </v-card>

    <new-addr-modal
      :open="showAddModal"
      @close="closeAddModal"
    />

    <addr-delete-modal
      :ip="addr"
      :open="showIpDeleteModal"
      @close="closeIpDeleteModal"
    />
  </div>
</template>

<script>
import AddrDeleteModal from './AddrDeleteModal.vue'
import NewAddrModal from './NewAddrModal.vue'
import NtpTable from './NtpTable.vue'

export default {
  components: {
    NtpTable,
    NewAddrModal,
    AddrDeleteModal
  },
  data () {
    return {
      status: false,
      showAddModal: false,
      addr: '',
      showIpDeleteModal: false
    }
  },
  created () {
    this.status = this.statInfo.ntp_enabled === 1
  },
  computed: {
    ntpList () {
      const ntpInfo = this.$store.state.hsm.statInfo.ntp_srv_info
      return ntpInfo.map((item) => {
        return item.addr
      })
    },
    statInfo () {
      return this.$store.state.hsm.statInfo
    }
  },
  methods: {
    loadDate () {
      this.$store.dispatch('hsm/getNetInfo')
      this.$store.dispatch('hsm/getStatInfo')

      this.status = this.statInfo.ntp_enabled === 1
    },
    changeStatus () {
      this.$store
        .dispatch('hsm/enable_ntp', {
          body: {
            state: this.status ? 1 : 0
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    openAddModal () {
      this.showAddModal = true
    },
    closeAddModal () {
      this.loadDate()
      this.showAddModal = false
    },
    openIpDeleteModal (item) {
      this.addr = item.addr
      this.showIpDeleteModal = true
    },
    closeIpDeleteModal () {
      this.loadDate()
      this.showIpDeleteModal = false
    },
    refreshData () {
      this.loadDate()
    }
  }
}
</script>
